import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'gatsby';
import { slugify } from '../../utils/functions';
import { StyledChip } from './styles';

const Chip = ({ link, label, amount, currency }) => {
  const text =
    amount && amount >= 0.1
      ? new Intl.NumberFormat('en', {
          style: 'currency',
          currency: currency,
        }).format(amount)
      : amount && amount <= 0.1
      ? 'Free'
      : label;

  return (
    <StyledChip>
      {link ? (
        <Link to={`/premade/${slugify(label)}`}>{text}</Link>
      ) : (
        <span>{text}</span>
      )}
    </StyledChip>
  );
};

Chip.propTypes = {
  link: PropTypes.string,
  label: PropTypes.string,
  amount: PropTypes.number,
  currency: PropTypes.string,
};
Chip.defaultProps = {
  link: null,
  label: null,
  amount: null,
  currency: 'usd',
};

export default Chip;
